import { words } from './dictionary'
import { createSalt, randomFromArray } from './random-slug'

/**
 * Generates a random team slug with low chance of
 * clashing.
 *
 * For any real entity data, we should always be relying
 * on the server to generate, validate and conflict-check
 * slugs.
 *
 * Prefix and suffix must both be plain alphanumeric
 * values. Prefix cannot start with a number.
 *
 * @example awesome-beans-j2uf9dk3
 */
export function randomTeamSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}

/**
 * Generate a random access group slug
 */
export function randomAccessGroupSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(3)}`
}

/**
 * Generate a random managed doc slug
 */
export function randomManagedDocSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}
/*
 * Generate a random ruleset slug
 */
export function randomRulesetSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}

/**
 * Generate a random managed schema slug
 */
export function randomManagedSchemaSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}

/**
 * Generate a random login portal slug
 */
export function randomLoginPortalSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}

/**
 * Generate a random login portal slug
 */
export function randomThemeSlug() {
  return `${randomFromArray(words.adjectives)}-${randomFromArray(words.nouns)}-${createSalt(7)}`
}
